import React, {useEffect, useState} from "react";
import "./AnnouncementBar.css";

export default function AnnouncementBar({
  messages,
  header,
  textColor = "#fff",
}) {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    if (!header || messages.length <= 1) return;
    const id = setInterval(() => {
      setIndex((i) => (i + 1) % messages.length);
    }, 3800);
    return () => clearInterval(id);
  }, [header, messages.length]);

  if (!header) {
    const group = (groupKey, hidden) => (
      <div
        className="marquee-group"
        aria-hidden={hidden || undefined}
        key={groupKey}
      >
        {messages.map((msg, i) => (
          <span key={i} className="marquee-item" style={{color: textColor}}>
            {msg}
            <span className="marquee-sep" aria-hidden="true"></span>
          </span>
        ))}
      </div>
    );

    return (
      <div className="marquee">
        <div className="marquee-track">
          {group("a", false)}
          {group("b", true)}
        </div>
      </div>
    );
  }

  return (
    <div className="announce-bar">
      <span
        key={index}
        className="announce-bar-text"
        style={{color: textColor}}
      >
        {messages[index]}
      </span>
    </div>
  );
}
